import React from 'react';
import { titleByCode } from '../../config/ifrTitles';

export const RS = {
  page: { minHeight: '100vh', background: '#F6F4EE', fontFamily: "'Plus Jakarta Sans', sans-serif", padding: '20px 16px 60px' },
  wrap: { maxWidth: '720px', margin: '0 auto' },
  back: { fontSize: '12.5px', color: '#6B7280', cursor: 'pointer', marginBottom: '14px' },
  hero: {
    background: 'linear-gradient(135deg, #0B3524, #175239)', color: '#fff',
    borderRadius: '20px', padding: '26px 22px', marginBottom: '18px',
  },
  heroLabel: { fontSize: '10.5px', letterSpacing: '1.6px', opacity: 0.7, fontWeight: 800 },
  h1: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '26px', margin: '9px 0 10px', lineHeight: 1.15 },
  heroText: { fontSize: '13px', lineHeight: 1.7, opacity: 0.9 },
  heroLink: { fontSize: '12.5px', fontWeight: 700, marginTop: '14px', cursor: 'pointer', color: '#FBBF77' },
  card: { background: '#fff', border: '1px solid #E8E4DA', borderRadius: '18px', padding: '20px', marginBottom: '16px' },
  h2: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '18px', color: '#14452F', margin: '0 0 14px' },
  row: {
    background: '#fff', border: '1px solid #E8E4DA', borderRadius: '13px',
    padding: '13px 15px', marginBottom: '9px', display: 'flex',
    alignItems: 'center', gap: '12px', cursor: 'pointer',
  },
  rank: { width: '26px', fontSize: '12.5px', fontWeight: 800, color: '#9CA3AF', flexShrink: 0, textAlign: 'right' },
  name: { fontSize: '14px', fontWeight: 700, color: '#1A1A1A' },
  meta: { fontSize: '11.5px', color: '#6B7280', marginTop: '3px' },
  rating: { fontSize: '18px', fontWeight: 800, color: '#14452F', fontVariantNumeric: 'tabular-nums' },
  badge: {
    fontSize: '10.5px', fontWeight: 900, padding: '3px 7px',
    borderRadius: '6px', letterSpacing: '0.4px',
  },
  input: {
    width: '100%', padding: '12px 14px', borderRadius: '11px', border: '1px solid #E8E4DA',
    fontSize: '14px', fontFamily: 'inherit', background: '#fff', boxSizing: 'border-box',
  },
  check: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12.5px', color: '#6B7280', marginBottom: '12px', cursor: 'pointer' },
  empty: { background: '#fff', border: '1px solid #E8E4DA', borderRadius: '16px', padding: '34px 20px', textAlign: 'center', fontSize: '13px', color: '#6B7280', lineHeight: 1.7 },
  footer: { fontSize: '12px', color: '#6B7280', lineHeight: 1.8, textAlign: 'center', padding: '16px 12px' },
  inlineLink: { color: '#14452F', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' },
  btn: {
    background: 'linear-gradient(135deg, #14452F, #1F6B45)', color: '#fff', border: 'none',
    padding: '13px 22px', borderRadius: '11px', fontSize: '14px', fontWeight: 700,
    cursor: 'pointer', fontFamily: 'inherit',
  },
  btnGhost: {
    background: '#fff', color: '#14452F', border: '1px solid #E8E4DA',
    padding: '11px 18px', borderRadius: '11px', fontSize: '13px', fontWeight: 700,
    cursor: 'pointer', fontFamily: 'inherit',
  },
  label: { display: 'block', fontSize: '12px', fontWeight: 700, color: '#374151', marginBottom: '6px' },
  err: { background: '#FEF2F2', color: '#991B1B', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', marginBottom: '14px' },
  ok: { background: '#ECFDF5', color: '#065F46', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', marginBottom: '14px' },
};

export function TitleBadge({ code, size = 'sm' }) {
  const t = titleByCode(code);
  if (!t) return null;
  return (
    <span
      title={`${t.name} — ${t.english}`}
      style={{
        ...RS.badge,
        background: `${t.color}18`,
        color: t.color,
        fontSize: size === 'lg' ? '13px' : '10.5px',
        padding: size === 'lg' ? '5px 10px' : '3px 7px',
      }}
    >
      {t.code}
    </span>
  );
}
